import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Dubai_Tram_Depot.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Dubai Tram</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>The 10.6 km Dubai Tram network connecting Jumeirah Beach Residence and Dubai Marina — the first tram network in the
                Middle East to operate using a catenary-free power supply system. A landmark piece of urban transit infrastructure serving
                one of Dubai's most densely populated waterfront districts.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
              <p>GEMCO SCOPE OF WORKS : CHW and electrical works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one